import type { ContextModalProps } from '@mantine/modals';

import type { AppModalProps } from '@/new_src/view/components/WebView/AppModal';
import * as S from '@/new_src/view/components/WebView/Native/IOS/IOSModal/styles';

import { translate } from 'utils/LocaleUtil';

const IOSModal = ({ context, id, innerProps }: ContextModalProps<AppModalProps>) => {
  const close = () => context.closeModal(id);
  return (
    <>
      <S.ContentWrapper>{innerProps.modalBody}</S.ContentWrapper>
      <S.ButtonWrapper>
        <button
          onClick={
            innerProps.confirmButton?.onClick
              ? () => {
                  innerProps.confirmButton?.onClick?.();
                  close();
                }
              : close
          }
        >
          {innerProps.confirmButton?.label || translate('ok')}
        </button>
        {innerProps?.cancelButton && (
          <button
            onClick={
              innerProps.cancelButton?.onClick
                ? () => {
                    innerProps.cancelButton?.onClick();
                    close();
                  }
                : close
            }
          >
            {innerProps.cancelButton?.label || translate('cancel')}
          </button>
        )}
      </S.ButtonWrapper>
    </>
  );
};

export default IOSModal;
